import { bessMockData } from './MockData/bessMockData';
import { modules, moduleTemplates } from './MockData/moduleLibraryMockData';
import lastEntries from './MockData/lastEntriesMockData.js';
import organizations from './MockData/organizationsMock';
export const mockApi = (url) => {
  return new Promise((resolve) => {
    if (url === '/api/v1/battery-energy-storage-systems/') {
      resolve(bessMockData);
    } else if (url.includes('/battery-energy-storage-systems/')) {
      resolve(bessMockData[0]);
    } else if (url.includes('module-templates')) {
      resolve(moduleTemplates);
    } else if (url.includes('modules')) {
      resolve(modules);
    } else if (url.includes('last-entries')) {
      resolve(lastEntries);
    } else if (url.includes('token')) {
      resolve({ access_token: 'dummy_token', expires_in: 3600 });
    } else if (url.includes('organizations')) {
      resolve(organizations);
    } else if (url.includes('user')) {
      resolve({
        organizationId: 'd7f0b5d3-17ae-4bbc-a2b2-4da53cdadb32',
        userName: 'Einar'
      });
    } else {
      resolve({ data: [] });
    }
  });
};
